import { SharedStyles } from '@opencare/shared-styles';
import { IconX } from '@tabler/icons-react';
import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { applyStylesForScreenSize, SCREEN_SIZES } from 'brand-guidelines/utils/screenSizeUtils';
import { Modal } from 'opencare-crown';

export const NoOffersModalContainer = styled(Modal).attrs({
  centered: true,
  width: '',
  destroyOnClose: true,
  footer: null,
  closable: false,
})`
  && {
    width: 520px;

    .ant-modal-content {
      border-radius: 8px;
    }

    .ant-modal-body {
      padding: 0;
    }

    .ant-modal-footer {
      display: none;
    }
  }

  ${applyStylesForScreenSize([SCREEN_SIZES.PHONE, SCREEN_SIZES.TABLET], css`
    max-width: 343px;
  `)}
`;

export const CloseButton = styled(IconX).attrs({
  size: 24,
  color: BRAND_COLORS.darkGray,
})`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;

export const NoOffersModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 28px;

  padding: 24px;
  padding-top: 54px;

  text-align: center;
`;

export const TextContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Title = styled.span`
  ${TYPOGRAPHY.CIRCULAR.black}
  max-width: 420px;

  font-size: 32px;
  line-height: 40px;
  color: ${SharedStyles.COLOR.TEXT.SECONDARY.DEFAULT};

  margin: 0;
`;

export const Subtitle = styled.p`
  ${TYPOGRAPHY.OPEN_SANS.base}

  max-width: 400px;

  font-size: 16px;
  line-height: 24px;
  color: ${BRAND_COLORS.darkGray};

  margin: 0;
`;

export const OfferNameText = styled.span`
  ${TYPOGRAPHY.OPEN_SANS.bold}
`;

export const CtaContainer = styled.div`
  align-self: stretch;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

interface ButtonProps {
  $type: 'continue' | 'find-providers' | 'go-back';
}

const BUTTON_STYLES = {
  continue: css`
    background-color: ${SharedStyles.COLOR.SURFACE.PRIMARY.DEFAULT};
    color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE};
    border-color: ${SharedStyles.COLOR.BORDER.PRIMARY.DEFAULT};

    &:hover {
      background-color: ${SharedStyles.COLOR.SURFACE.PRIMARY.HOVER};
      border-color: ${SharedStyles.COLOR.BORDER.PRIMARY.HOVER};
    }
  `,
  'find-providers': css`
    background-color: ${SharedStyles.COLOR.SURFACE.DEFAULT.INVERSE};
    color: ${SharedStyles.COLOR.TEXT.PRIMARY.DEFAULT};
    border-color: ${SharedStyles.COLOR.BORDER.PRIMARY.DEFAULT};

    &:hover {
      background-color: ${SharedStyles.COLOR.SURFACE.PRIMARY.DEFAULT};
      color: ${SharedStyles.COLOR.TEXT.DEFAULT.INVERSE};
    }
  `,
  'go-back': css`
    color: ${SharedStyles.COLOR.TEXT.PRIMARY.DEFAULT};
    background-color: transparent;
    border: 0;

    &:hover {
      color: ${SharedStyles.COLOR.TEXT.PRIMARY.HOVER};
    }
  `,
};

export const Button = styled.button<ButtonProps>`
  ${TYPOGRAPHY.CIRCULAR.bold}

  height: 44px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 14px 32px;

  border-radius: 64px;
  border: 1px solid;

  cursor: pointer;

  transition: all 0.3s ease;

  ${({ $type }) => BUTTON_STYLES[$type]}
`;
